<script>
import Layout from "../../layouts/main";
//import appConfig from "@/app.config";
import countTo from 'vue-count-to';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import BannerApi from "@/services/banner-api";

export default {
  /*page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },*/
  components: {
    Layout,countTo
  },
  data() {
    return {

      counterVisible: false,
      keyCounterVisible:0,

      mediaFeaturesVisible: false,
      iconsVisible: false,

      bannerList: [],
      icons: [
        { imgSrc: 'car-3-svgrepo-com', altText: 'default.icons.1.altText', text: 'default.icons.1.text' },
        { imgSrc: 'family-of-3-whole-body-svgrepo-com', altText: 'default.icons.2.altText', text: 'default.icons.2.text' },
        { imgSrc: 'plane-svgrepo-com', altText: 'default.icons.3.altText', text: 'default.icons.3.text' },
        { imgSrc: 'tray-dish-svgrepo-com', altText: 'default.icons.4.altText', text: 'default.icons.4.text' }
      ],

      referencesLogos: [
        
      ],

      isBannerTableBusy: false,
      mediaFeatures: [
      {
        id: "1",
        icon: "clock-circle-svgrepo-com",
        alt: "Catalogue",
        title: "Catalogue en temps réel",
        description: "Consulter nos produits, prix et disponibilités en temps réel"
      },
      {
        id: "2",
        icon: "delivery-truck",
        alt: "Commandes en ligne",
        title: "Commandes en ligne",
        description: "Gérez vos commandes en ligne et accédez facilement à votre historique"
      },
      {
        id: "3",
        icon: "deal-svgrepo-com",
        alt: "Promotions et actualités",
        title: "Promotions et actualités",
        description: "Restez informé de nos promotions et actualités"
      },
     
      ],

    

      counterItems: [
        {
          width: '70px',
          moreThanText: 'plus de',
          endVal: 300,
          duration: 3000,
          title: 'Clients',
        },
        {
          width: '70px',
          moreThanText: 'plus de',
          endVal: 15000,
          duration: 3000,
          title: 'Produits disponibles',
        }
      ]


    };
  },

  computed: {
    windowWidth() {
      return window.innerWidth;
    },

    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },

    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
        phone2: process.env.VUE_APP_CUSTOMER_PHONE2,
      };

      return vueAppCustomerInfo;
    },

  },

  watch:{
    mediaFeaturesVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },
    iconsVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },

    counterVisible(newValue) {
      if (newValue) {
        this.keyCounterVisible ++
      }
    }
  },

  mounted() {
    this.findBanner(this.windowWidth);
    this.initIntersectionObserver()
    this.initIntersectionObserverIconsSection()
    this.observeImages()
    this.observeImagesRight()
    this.initIntersectionCounterObserver()
  },

  methods: {

    initIntersectionCounterObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.counterVisible = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.counterSection);
    },

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
        
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    initIntersectionObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.mediaFeaturesVisible = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.mediaFeaturesSection);
    },

    initIntersectionObserverIconsSection() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.iconsSection = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.mediaFeaturesSection);
    },


    observeImagesRight() {
      const images = document.querySelectorAll('.image-slide-right-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, 
      { threshold: 0.1,}
    );

      images.forEach(image => {
        observer.observe(image);
      });
    },

    observeImages() {
      const images = document.querySelectorAll('.image-slide-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    },
    
    observeIcons() {
      const images = document.querySelectorAll('.fadeInUp');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    }

  }
};
</script>

<template>
  <Layout>

    <!-- Main Banners -->
    <div class="row pt-xl-0 " >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide class="bg-light"  
                          style="width:1920px; height:565px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-secondary">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                  <template #img>
                    <div class="banner-overlay"></div>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%" style="min-height:200px; max-height:480px;">
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-center">
                   <img src="@/assets/images/avn/logo.png" alt height="120rem"/>
                    <!-- <h1 class="font-weight-bold banner-title-white text-primary" style="font-size:4.5rem !important;">Avenir Pharma</h1> -->
                    <h2 class=" text-success mt-4 banner-title-white d-none d-md-block" style="font-size:2.5rem !important;"> Grossiste Répartiteur de produits pharmaceutiques et parapharmaceutiques </h2>

                  <h2 class="text-primary font-weight-bold font-size-24 mt-3 mb-5 banner-title d-none d-md-block">
                    À votre disposition, avec professionnalisme et réactivité !
                  </h2>

                  <h3 class="text-white font-weight-bold text-center font-size-22 mt-2 banner-title d-none d-md-block" style="font-size:1.2rem !important;">
                    {{vueAppCustomerInfo.address}}
                  </h3>


                  <!-- <div class="mt-4" >
                    <a class="pr-3" href="/catalogue">
                      <b-button variant="light"  style="padding: 10px 26px; " class="font-weight-bold  font-size-18">
                        <div class="font-weight-normal mb-1 text-dark font-size-14">Consulter notre catalogue et passez vos</div>
                        <span class="font-weight-bold text-primary text-uppercase">Commandes en ligne</span>
                      </b-button>
                    </a>    
                   
                  </div> -->
                </div>
                
              
            </b-carousel>



        </div>
      </div>


    </div>

   


    <div class="bg-white pt-md-0 pt-md-0 pt-0 mt-5 pb-5 ">
  
      <div class="d-md-none d-block mb-4">


            <h2 class=" text-success mt-4 banner-title-white text-center" style="font-size:2rem !important;"> Grossiste Répartiteur de produits pharmaceutiques et parapharmaceutiques </h2>

            <h3 class="text-primary font-weight-bold text-center font-size-22 mt-4 banner-title-white" style="font-size:1rem !important;">
              {{vueAppCustomerInfo.address}}
            </h3>

        </div>


        <div ref="mediaFeaturesSection" class=" row pt-md-0 pt-3 text-center justify-content-center ">
            <div 
              v-for="(feature, index) in mediaFeatures" 
              :key="feature.id"  
              class="col-md-4 col-12 mb-4 mt-4 pr-4 pl-4 fadeInUp" 
              :style="{ animationDelay: (index * 0.05) + 's' }"
              ref="mediaFeatureElements"
            >
              <img 
                :alt="feature.alt" 
                class="mb-2" 
                v-if="feature.icon" 
                :src="require('@/assets/images/' + feature.icon + '.svg')" 
                width="50px"
              > 
              <h4 class=" mt-3 mb-2 font-weight-bold text-primary text-uppercase">{{ feature.title }}</h4>
              <p class="mt-4 text-dark font-size-16 text-dark text-center">{{ feature.description }}</p>
            </div>
        </div>

        

    </div>
















<!-- Au service des pharmaceins -->
<div class="bg-light pt-md-5 pt-3 ">
        <div class="home-page-80-width">

            <div class="row">

            

              <div class="col-lg-6 col-12 text-primary p-md-5 p-3 my-auto">

                <div class="text-dark font-weight-bold text-center" style="font-size:2rem;">
                  Qui Sommes-Nous ?
                </div>

                <hr class="separator-line mt-3 mb-3">



                
                <p class="text-dark mt-5 text-justify font-size-16 p-2" style="line-height: 2;">
                  Avenir Pharma Gros est une entreprise tunisienne spécialisée dans le commerce de gros des produits pharmaceutiques et parapharmaceutiques. Située Route Manzel Chaker à sfax, l'entreprise bénéficie de plus de dix années d'expérience dans le domaine de la distribution lui permettant ainsi d'offrir des services fiables, efficaces et parfaitement adaptés aux exigences du marché.
                </p>

                <!-- <span class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
                  {{$t('ourPartner.subtitle1')}}
                </span> -->

                <!-- <div class="d-flex justify-content-center mt-5 pt-5">
                    <a class="pr-3" href="/catalogue">
                      <b-button variant="primary"  style="padding: 10px 26px; letter-spacing:1px;" class="font-weight-bold  font-size-18">
                        <div class="font-weight-normal mb-1 text-light font-size-14">Consulter notre catalogue et passez vos</div>
                        <span class="font-weight-bold  text-uppercase">Commandes en ligne</span>
                      </b-button>
                    </a>    
                </div> -->


                

              </div>



                <div class="col-lg-6 col-12 align-items-center justify-content-center p-5">
                

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4102.200116309725!2d10.7128478763633!3d34.74689738073165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301d33a090a3571%3A0xcd22fb8484634270!2sAVENIR%20PHARMAGROS!5e1!3m2!1sen!2stn!4v1762121866771!5m2!1sen!2stn"
              width="100%" height="100%" frameborder="0" style="border:0; min-height: 400px; border-radius:10px;" allowfullscreen=""
              loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            ></iframe>



              </div>
              

            </div>

        </div>
    </div>







    <!--  Counter Section  -->
    <div class="bg-white pt-md-5 pt-3 pb-2">

       
      
      <div class="bg-white p-md-3 p-3">
            <!-- <h3 class="text-primary text-center font-weight-bold mt-2 banner-title-white " > 
                <span style="font-size:2rem; letter-spacing: 2px;" class="d-none d-md-inline font-weight-bold text-uppercase">AVENIR PHARMA EN CHIFFRES</span>
            </h3> -->

            <!--div class="pt-5 text-dark text-center font-weight-bold " style="font-size:2rem;">
            Nos chiffres clés
          </div>

        <hr class="separator-line mt-3 mb-3"-->


         <div class="row">


          <div class="col-lg-6 col-12 d-none d-lg-flex align-items-center justify-content-center p-5">
                <img  
                  class="" 
                  
                  src="@/assets/images/avn/logo.png" 
                  alt="Au service des pharmaciens" 
                  width="500px;" height="auto"  
                  style="border-radius: 8px; "
                />
          </div>

   
          <div class="col-lg-6 col-12 text-primary p-md-5 p-3 my-auto">
              <div ref="counterSection" class="mt-0 text-white">
                <div>
                    <div class="row p-md-4 -0">
                      <div class="col-12 text-center">
                          <div class="row ml-md-4 ml-0 mr-md-4 mr-0 pt-3 pb-3">
                          <div 
                              v-for="(item, index) in counterItems" 
                              :key="index" 
                              class="col-md-6 col-12 text-center pt-md-0 pt-4 pb-md-0 pb-4 "
                          >
                            
                              <span class="font-size-16  text-secondary ">
                                <i>{{ item.moreThanText }}</i>
                              </span>

                              <countTo 
                              :key="keyCounterVisible"
                              class="m-2 banner-title-white text-primary " 
                              style="font-weight:900;" 
                              :autoplay="counterVisible" 
                              separator=" " 
                              :startVal="0" 
                              :endVal="item.endVal" 
                              :duration="item.duration"
                              />

                              <h2 class="text-center mt-2 text-primary ">{{ $t(item.title) }}</h2>

                          </div>
                          </div>
                      </div>


                      

              </div>

            

              



          </div>








          







              </div>
</div>
        

          </div>



      




      



</div>







</div>






<div class="bg-light mt-2 mt-md-5"  >
          <div class="row pt-0 pt-md-5 " style="margin: auto;max-width: 80%;letter-spacing: 0.01em; padding-bottom: 50px; ">
            <div class="col-12"> 

                <div class="row pb-1">

                  <div class="col-xl-5 col-md-6 col-sm-12 col-xs-12 text-md-left pr-2 text-left d-none d-xl-block" >
                    <h1 class="font-weight-bold banner-title-white text-primary text-uppercase" style="font-size:2rem !important;">AVENIR PHARMA GROS</h1>
                  </div>


                  <div class="col-xl-7 col-md-12 col-sm-12 col-xs-12 pl-2">

                    <div class="row">

                      <div class="col-xl-4 col-md-4 col-sm-12 col-xs-12 p-2 text-left pt-md-0 pt-4" >
                          <h5 class="text-dark font-weight-bold " >CONTACTEZ-NOUS</h5>


                            <ul style="list-style: none;margin: 0;padding: 0; " class="mt-4">
                                <li class="text-dark font-weight-normal font-size-14 mt-2">
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.address}}</span>
                                </li>

                                <li class="font-weight-normal font-size-14 mt-2">
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.email}}</span>
                                </li>          
                                
                                <li class=" font-weight-normal font-size-14 mt-2">
                                  <span class="text-dark font-weight-normal font-italic">Du lundi au Samedi de 07h à 00h et Dimanche de 07h à 14h30</span>
                                </li>

                                <li class=" font-weight-normal font-size-14 mt-2">
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.phone}}</span>
                                </li>    
                                <li class=" font-weight-normal font-size-14 mt-2">
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.phone2}}</span>
                                </li>   
                            </ul>
                        </div>
                        <div class="col-xl-4 col-md-4 col-sm-12 col-xs-12 p-2 text-left pt-md-0 pt-4">
                            <h5 class="text-dark font-weight-bold text-uppercase">Menu</h5>
                            
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                        
                        <li class="font-size-14 mt-2 ">
                              <a class="text-dark" href="/catalogue">Tout le catalogue</a>
                            </li>

                        <li class="font-size-14 mt-2">
                              <a class="text-dark" href="/catalogue">Produits Pharmaceutiques</a>
                            </li>

                            <li class="font-size-14 mt-2">
                              <a class="text-dark" href="/catalogue">Produits Para-Pharmaceutiques</a>
                            </li>


                        </ul>

                    


                          </div>
                        <div class="col-xl-4 col-md-4 col-sm-12 col-xs-12 p-2 text-left pt-md-0 pt-4" >
                          <h5 class="text-dark font-weight-bold text-uppercase" style="">{{customerPortalName}}</h5>
                          <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                              
                                <li class="font-size-14 mt-2">
                                  <a class="text-dark" href="/catalogue">Espace Client</a>
                                </li>
                                
                                <li class="font-size-14 mt-2">

                                  <a class="text-dark" href="/catalogue">Espace Fournisseur</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                  </div>



                </div>
            </div>
          </div>
          </div>


    

   

  </Layout>
</template>

<style scoped>




.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
/*  background-color: #adbfaf1f;*/

    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 60%, rgba(255, 255, 255, 1) 100%);


  z-index: 1;
  pointer-events: none;
}

/* Hover Effect (Optional: Adds a modern interaction on hover) */
/* .banner-overlay:hover {
  filter: blur(5px);
  opacity: 0.8; 
} */

.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #fff; font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); 
  font-weight: 700;
}
@media (min-width: 768px) {
  .banner-title {
    font-size: 4rem;
  }
}

/* Mobile Version */

.banner-title-dark {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #121212; font-weight: 700;
}
.banner-title-mobile {
  font-size:2rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #fff; 
  font-weight: 700;
}





.carousel-caption {
  position: absolute;
  padding-left: 5%;
  top: 40%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
}

@media (max-width: 768px) {
  .carousel-caption {
    position: absolute;
    padding-left: 5%;
    top: 30%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2;
  }
}

.left-border {
  border-left: 3px solid #137437;
  padding-left: 10px;
}


.header {
    background:  linear-gradient(19deg,#37985b 0%,#137437 , rgba(23, 83, 45, 1) 100%)!important;
    text-align: center;
  }

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 70%;
  }
}
.separator-line {
  width: 20%;
  height: 6px;
  background: linear-gradient(90deg, #126b3c, #ddd);
  border-radius: 10px;
  border: none;
  margin: auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}


.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}



</style>

<style scoped>
.logo-card {
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #fff;
}
.logo-card:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}
.logo-img {
  max-height: 60px;
  object-fit: contain;
}
.swiper-container {
  padding-bottom: 20px;
}
</style>

<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/*.fadeInUp {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.fadeInUp.animate {
  animation: fadeInUp 0.6s ease-in-out forwards;
}*/
</style>

<style scoped>








.image-overlay {
  background: #294639c9  ; 
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
}


</style>


<style scoped>
.circle-icon {
  display: inline-block;
  background-color: #252525;
  border-radius: 50%;
  padding: 20px;
  width: 120px;
  height: 120px; 
  opacity: 0.7;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.circle-icon img {
  width: 60px;
  height: 60px; 
}

.white-box {
  background-color: #fff;
  max-width: 600px;
  transform: translateY(-100px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
}

fieldset.scheduler-border {
  border: 2px solid #137437;
  padding: 1.5em;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

legend.scheduler-border {
  font-size: 1.4em;
  font-weight: bold;
  color: #137437;
  padding: 0 10px;
  text-align: center;
}

.control-group {
  margin-top: 10px;
  line-height: 1.6;
}



</style>


<style scoped>
.image-slide-in {
  width: 400px;
  transform: translateX(-100%);
  opacity: 0; 
  transition: transform 1s ease-out, opacity 1s ease-out;
}


.image-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}

.dashboard-image {
    width: 100%;
    max-width: 600px;
    border: 8px solid #137437;
    border-radius: 10px;
    box-shadow: 0 10px 20px #13743793;
    transform: rotate(0deg); /* Initial rotation */
    transition: transform 1s ease-out, box-shadow 1s ease-out; /* Add transition for rotation */
}

.image-slide-right-in {
    width: 600px;
    transform: translateX(100%); /* Initially off-screen to the right */
    opacity: 0;
    transition: transform 1s ease-out, opacity 1s ease-out; /* Sliding effect */
}

.image-slide-right-in.animate {
    transform: translateX(0) rotate(0deg); /* Slide to normal position and apply rotation */
    opacity: 1;
}

@media (max-width: 450px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 270px;
  }
}

@media (min-width: 450px) and (max-width: 1300px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 360px;
  }
}


  </style>